import styled from 'styled-components';

import { Input as AntdInput } from 'antd';

import { inputStylesOverride } from './BaseInput';

const TextArea = styled(AntdInput.TextArea)`
    ${inputStylesOverride};
`;

export default TextArea;
